// extracted by mini-css-extract-plugin
export default {"notFound":"notFound_notFound__e7wOD","footnote":"notFound_footnote__+TUjF"};